"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Tarot Cards",
  subtitle: "Manage the tarot card library",
  listEndpoint: "tarot-card/card-list",
  countEndpoint: "tarot-card/card-list-count",
  statusEndpoint: "tarot-card/card-status-change",
  deleteEndpoint: "tarot-card/card-delete",
  addPath: "/admin/tarot/cards/add",
  editPath: "/admin/tarot/cards/edit",
  addButtonLabel: "+ Add Card",
  nestedPagination: true,
  statusPayloadType: "package",
  defaultSortField: "created_on",
  defaultSortType: "desc",
  columns: [
    { key: "card_name", label: "Card Name", sortable: true },
    // TC-02: "card_number" does not exist in Angular — removed
    { key: "priority", label: "Priority", type: "number", sortable: true },
    // TC-09: Add related_spread_name and updated_on columns
    { key: "related_spread_name", label: "Related Spreads" },
    { key: "status", label: "Status", type: "status" },
    // TC-08: API returns "created_on" not "created_at"
    { key: "updated_on", label: "Updated On", type: "date", sortable: true },
    { key: "created_on", label: "Created On", type: "date", sortable: true },
  ],
  searchFields: [
    { label: "Card Name", field: "card_name", placeholder: "Search by card name..." },
    { label: "Related Spread", field: "related_spread_name", placeholder: "Search by spread name..." },
  ],
  // TC-10: Add status filter
  filterFields: [
    {
      label: "Status",
      field: "status",
      values: [
        { val: "1", name: "Active" },
        { val: "0", name: "Inactive" },
      ],
    },
  ],
  // TC-11: Date range filters
  dateRangeFields: [
    { label: "Created On", field: "created_on" },
    { label: "Updated On", field: "updated_on" },
  ],
  // TC-12: Row preview
  previewFromRow: true,
  previewFields: [
    { key: "card_name",           label: "Card Name" },
    { key: "related_spread_name", label: "Related Spreads" },
    { key: "priority",            label: "Priority" },
    { key: "description",         label: "Description" },
    { key: "card_image",          label: "Card Image", type: "image" },
    { key: "updated_on",          label: "Updated On", type: "date" },
    { key: "created_on",          label: "Created On", type: "date" },
    { key: "status",              label: "Status", type: "badge" },
  ],
};

export default function TarotCardsPage() {
  return <GenericListPage config={config} />;
}
